import { ImageService } from './../../_services/image.service';

import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-image-answer-concept',
  templateUrl: './image-answer-concept.component.html',
  styleUrls: ['./image-answer-concept.component.css']
})
export class ImageAnswerConceptComponent implements OnInit {
  @Input() questionId:number=0
  @Input() mediaFileName:string=""
  @Input() conceptPartName:string=""
  imageSource:any=undefined;
  loading=true

  constructor(private imageService:ImageService) {}

  ngOnInit(): void {
    if(this.questionId!=0){
      this.imageService.imageAnswerConceptMediaFile(this.questionId,this.mediaFileName).subscribe(
        base64Image=>{
           this.imageSource = "<img src=data:image/png;base64,"+base64Image+">";

           this.loading=false
        }
      )
      }

    }
  }
